module.exports = __webpack_public_path__ + "static/media/hosting.89737a8e.svg";